import React, {useEffect, useState} from 'react'
import { Styled } from './styled'
import ArrowIcon from '~images/arrow.svg'

export interface IItem {
  title: string | JSX.Element,
  text: string | JSX.Element
}

interface IProps {
  data: IItem[],
  initialElemIndex: number | null,
  onChange?: Function
}

const Accordion: React.FC<IProps> = props => {
  const [activeItemIndex, setActiveItemIndex] = useState(null)
  
  useEffect(() => {
    if (props.initialElemIndex !== null)
      setActiveItemIndex(props.initialElemIndex)
  }, [props.initialElemIndex])

  return (
    <Styled.Container>
      <Styled.Items>
        {
          props.data.map((item: IItem, index: number) => (
            <>
              {
                index === activeItemIndex
                  ? <Styled.ItemActive key={index}>
                      <Styled.ItemTitle>{item.title}</Styled.ItemTitle>
                      <Styled.ItemText>{item.text}</Styled.ItemText>
                    </Styled.ItemActive>
                  : <Styled.Item
                      key={index}
                      onClick={() => {
                        if (props.onChange)
                          props.onChange(index, item)

                        setActiveItemIndex(index)
                      }}
                    >
                      <Styled.ArrowIcon><ArrowIcon /></Styled.ArrowIcon>
                      <Styled.ItemTitle>{item.title}</Styled.ItemTitle>
                    </Styled.Item>
              }
            </>
          ))
        }
      </Styled.Items>
    </Styled.Container>
  )
}

export { Accordion }